import { allmap, anymap, concat, zip } from "./array.js";
import { identity, pipe } from "./composition.js";
import { isPromise } from "./promise.js";
import { map } from "./map.js";
export const juxt = (...fs) => (...x) => {
    const result = [];
    let anyAsync = false;
    for (const f of fs) {
        result.push(f(...x));
        anyAsync = anyAsync || isPromise(result[result.length - 1]);
    }
    // @ts-expect-error reason=ts does not understand me :_(
    return anyAsync ? Promise.all(result) : result;
};
export const pairRight = (f) => juxt((identity), f);
export const pairLeft = (f) => juxt(f, (identity));
export const stack = (...functions) => 
// @ts-expect-error reason: too complex
pipe((values) => zip([functions, values]), map(([f, x]) => f(x)));
export const juxtCat = (...fs) => 
// @ts-expect-error too complex
pipe(juxt(...fs), concat);
export const alljuxt = (...fs) => (...xs) => 
// @ts-expect-error cannot infer
allmap((f) => f(...xs))(fs);
export const anyjuxt = (...fs) => (...xs) => 
// @ts-expect-error cannot infer
anymap((f) => f(...xs))(fs);
